import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { toast } from 'sonner';
import { ArrowLeft, Users, Briefcase } from 'lucide-react';
import employeeApi from '../../lib/employeeApi';
import EmployeeLayout from '../../components/EmployeeLayout';

export default function DepartmentDetailPage() {
  const { departmentName } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await employeeApi.get(`/api/departments/${departmentName}/details`);
        setData(res.data);
      } catch (error) {
        toast.error('Failed to load');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [departmentName]);

  if (loading) return <EmployeeLayout><div className="p-8 text-center">Loading...</div></EmployeeLayout>;
  if (!data) return null;

  return (
    <EmployeeLayout>
      <div className="p-8">
        <Link to="/employee/departments" className="inline-flex items-center text-charcoal-600 hover:text-pink-600 mb-6"><ArrowLeft className="w-4 h-4 mr-2" />Back</Link>
        <h1 className="text-3xl font-bold text-charcoal-900 mb-8">{data.name}</h1>
        
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
          <div className="bg-white rounded-xl border border-charcoal-200 p-6">
            <Users className="w-8 h-8 text-pink-600 mb-3" />
            <p className="text-sm text-charcoal-600">Team Members</p>
            <p className="text-3xl font-bold text-charcoal-900">{data.member_count}</p>
          </div>
          <div className="bg-white rounded-xl border border-charcoal-200 p-6">
            <Briefcase className="w-8 h-8 text-pink-600 mb-3" />
            <p className="text-sm text-charcoal-600">Active Tasks</p>
            <p className="text-3xl font-bold text-charcoal-900">{data.task_count}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="bg-white rounded-xl border border-charcoal-200 p-6">
            <h3 className="text-lg font-semibold text-charcoal-900 mb-4">Team Members</h3>
            <div className="space-y-3">
              {data.members.map(member => (
                <Link key={member._id} to={`/employee/team/${member._id}`} className="block p-3 bg-charcoal-50 rounded-xl hover:bg-charcoal-100">
                  <p className="font-medium text-charcoal-900">{member.personal?.full_name || member.work_email}</p>
                  <p className="text-sm text-charcoal-600">{member.employment?.designation} • {member.employment?.employee_id}</p>
                </Link>
              ))}
            </div>
          </div>

          <div className="bg-white rounded-xl border border-charcoal-200 p-6">
            <h3 className="text-lg font-semibold text-charcoal-900 mb-4">Recent Tasks</h3>
            <div className="space-y-3">
              {data.tasks.slice(0, 10).map(task => (
                <div key={task._id} className="p-3 bg-charcoal-50 rounded-xl">
                  <p className="font-medium text-charcoal-900 text-sm">{task.title}</p>
                  <p className="text-xs text-charcoal-600">{task.task_type} • {task.priority}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </EmployeeLayout>
  );
}